import { usePartnerAuth } from '../context/PartnerAuthContext'

/**
 * usePartnerMode — Source unique de vérité pour savoir si l'utilisateur
 * courant est connecté en mode partenaire.
 *
 * Délègue à PartnerAuthContext (pas de requête supplémentaire).
 */
export function usePartnerMode(): { loading: boolean; isPartnerMode: boolean } {
  const { isPartner, loading } = usePartnerAuth()
  return { loading, isPartnerMode: isPartner }
}
